import { Link } from 'react-router-dom';

function ChevronRightIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M5.25 3.5L8.75 7L5.25 10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function HomeIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M2 5.5L7 1.75L12 5.5V11.5C12 11.8978 11.842 12.2794 11.5607 12.5607C11.2794 12.842 10.8978 13 10.5 13H3.5C3.10218 13 2.72064 12.842 2.43934 12.5607C2.15804 12.2794 2 11.8978 2 11.5V5.5Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5.25 13V8.75H8.75V13" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function LogoutIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M5.25 12.25H2.625C2.27982 12.25 2 11.9702 2 11.625V2.375C2 2.02982 2.27982 1.75 2.625 1.75H5.25"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.625 9.625L12 7.25L9.625 4.875"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 7.25H5.25" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function LogoutButton({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1.5 rounded-full border border-[#E02727]/20 bg-white px-3 py-1.5 text-[11px] font-medium text-[#E02727] shadow-[0_2px_8px_rgba(224,39,39,0.1)] transition active:scale-[0.97]"
    >
      <LogoutIcon />
      خروج
    </button>
  );
}

export function HomeNavButton({ to = '/' }) {
  return (
    <Link
      to={to}
      className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[11px] font-medium text-white shadow-[4px_5px_11px_rgba(0,0,0,0.1)] transition active:scale-[0.97]"
      style={{ background: 'linear-gradient(135deg, #54B0F8 0%, #914985 100%)' }}
    >
      <HomeIcon />
      خانه
    </Link>
  );
}

export function BackNavLink({ to, children }) {
  return (
    <Link
      to={to}
      className="inline-flex items-center gap-1.5 rounded-full border border-[#914985]/15 bg-white px-3 py-1.5 text-[11px] font-medium text-[#914985] shadow-[0_2px_8px_rgba(145,73,133,0.08)] transition active:scale-[0.97]"
    >
      <ChevronRightIcon />
      {children}
    </Link>
  );
}
